import { Component, OnInit, AfterViewInit, ViewChild } from '@angular/core';
import { Guid } from 'guid-typescript';
import { jqxButtonComponent } from 'jqwidgets-ng/jqxbuttons';
import { jqxDropDownListComponent } from 'jqwidgets-ng/jqxdropdownlist';
import { jqxGridComponent } from 'jqwidgets-ng/jqxgrid';
import { jqxInputComponent } from 'jqwidgets-ng/jqxinput';
import { jqxLoaderComponent } from 'jqwidgets-ng/jqxloader';
import { ToastrService } from 'ngx-toastr';
import { environment } from 'src/environments/environment';
import { ApiService } from '../api/api-service';
import { AppComponent } from '../app.component';
import { BdtCatalogoEquipModel } from '../models/bdt/bdt-cat-equip.model';
import { BdtEquipamientoModel } from '../models/bdt/bdt-equipamiento.model';
import { ElementoModel } from '../models/ecosat/elemento.model';
import { ModElemModel } from '../models/ecosat/mod-elem.model';
import { EmpresaIntraModel as EmpresaIntranetModel } from '../models/intranet/empresa.model';
import { ElementoNPModel } from '../models/np/elemento-np.model';
import { PosicionNPModel } from '../models/np/posicion-np.model';
import { ConfirmDialogService } from '../utils/confirm-dialog/confirm-dialog.service';
import { DateUtils } from '../utils/date-utils';
import { JqWidgets } from '../utils/jqWidgets';
import { TicketModel } from '../models/sso/ticket.model';
import { SelectionModel } from '../models/selection.model';
import { EmpresaSSOModel } from '../models/sso/empresa.model';
import { ConfigModel } from '../models/config/config.model';

@Component({
  selector: 'app-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.css']
})
export class MainComponent implements OnInit, AfterViewInit {
  @ViewChild('cbEmpresas') cbEmpresas: jqxDropDownListComponent;
  @ViewChild('cbEmpresas2') cbEmpresas2: jqxDropDownListComponent;
  @ViewChild('cbEmpresasNP') cbEmpresasNP: jqxDropDownListComponent;
  @ViewChild('cbEmpresasNP2') cbEmpresasNP2: jqxDropDownListComponent;
  @ViewChild('ebUrlApiEcoSAT') ebUrlApiEcoSAT: jqxInputComponent;
  @ViewChild('ebUrlApi') ebUrlApi: jqxInputComponent;
  @ViewChild('ebUrlNP') ebUrlNP: jqxInputComponent;
  @ViewChild('loader') loader: jqxLoaderComponent;
  @ViewChild('gridEcoSAT') gridEcoSAT: jqxGridComponent;
  @ViewChild('gridBDT') gridBDT: jqxGridComponent;
  @ViewChild('gridEcoSAT2') gridEcoSAT2: jqxGridComponent;
  @ViewChild('btnConectar') btnConectar: jqxButtonComponent;
  @ViewChild('btnAddModel') btnAddModel: jqxButtonComponent;
  @ViewChild('btnDelModel') btnDelModel: jqxButtonComponent;

  private static instance: MainComponent;
  public environment = environment;
  public urlApi: string;
  public urlApiEcoSAT: string;
  public urlApiIntranet: string;
  public urlApiBDT: string;
  public urlApiSSO: string;
  public urlApiIA: string;
  public urlWeb: string;
  public urlNP: string;
  public version = '251031.01';
  public anno = new Date().getFullYear();
  public empresaId = 0;
  public empresaIdMoviles = 0;
  public empresaGestionId = 0;
  public empresaNombre = '';
  private equipSelec: BdtEquipamientoModel = null;
  private modelElemEcoSAT: ModElemModel[] = [];
  private elementosEcoSAT: ElementoModel[] = [];
  private equipamientosBDT: BdtEquipamientoModel[] = [];
  private empresasIntranet: EmpresaIntranetModel[] = [];
  private empresasSSO: EmpresaSSOModel[] = [];
  private unidadesModElem = new Map<number, number>();
  private equipModelos = new Map<number, ModElemModel[]>(); // Modelos asignados a un equipamiento
  public modelosEquip = new Map<number, BdtEquipamientoModel>(); // Equipamiento de un modelo
  public conectando = false;
  public cancelar = false;
  public procesando = false;
  public procesoCancelado = false;
  private logArea: any = null;
  public borrarEquipamiento = false;
  public borrarElementos = true;
  public importarMoviles = true;
  public tabActive = 0;
  public crearEmpresa = false;
  public verEquipamientoGral = false;
  public ticketSSO: TicketModel;

  // Variables para el grid de EcoSAT
  public sourceEcoSAT: any = [];
  public dataAdapterEcoSAT = new jqx.dataAdapter(this.sourceEcoSAT);
  public columnsEcoSAT = [
    { text: 'Id', columntype: 'textbox', filtertype: 'textbox', datafield: 'id', width: 60, hidden: true },
    { text: '', columntype: 'image', datafield: 'imagen', width: 16, cellsrenderer: this.imageRenderer, menu: false },
    {
      text: 'Modelo', columntype: 'textbox', filtertype: 'textbox', datafield: 'nombre', width: 212,
      aggregates: [{
        'Total': function (aggregatedValue, currentValue: number) {
          return currentValue ? aggregatedValue + 1 : 1;
        }
      }],
      aggregatesrenderer: function (aggregates) {
        let renderstring = '';
        if (aggregates["Total"] !== undefined) {
          renderstring = '<div style="text-align: left; margin-left: 4px; padding-top:2px;">' + aggregates["Total"] + ' modelos</div>';
        }
        return renderstring;
      }
    },
    { text: 'Tipo', columntype: 'textbox', filtertype: 'textbox', datafield: 'tipo', width: 110 },
    // {
    //   text: 'Capac.', columntype: 'textbox', filtertype: 'textbox', datafield: 'capacidad', width: 55,
    //   align: 'center', cellsalign: 'center'
    // },
    {
      text: 'Unidades', columntype: 'textbox', filtertype: 'textbox', datafield: 'unidades', width: 70,
      align: 'center', cellsalign: 'center',
      aggregates: [{
        'Total2': function (aggregatedValue, currentValue: number) {
          return currentValue ? aggregatedValue + currentValue : aggregatedValue;
        }
      }],
      aggregatesrenderer: function (aggregates) {
        let renderstring = '';
        if (aggregates["Total2"] !== undefined) {
          renderstring = '<div style="text-align: center; padding-top:2px;">' + aggregates["Total2"] + ' </div>';
        }
        return renderstring;
      }
    },
    { text: 'Visible', columntype: 'textbox', filtertype: 'textbox', datafield: 'visible', hidden: true, width: 1 }
  ];

  // Variables para el grid de modelos asignados a los equipamientos
  public sourceEcoSAT2: any = [];
  public dataAdapterEcoSAT2 = new jqx.dataAdapter(this.sourceEcoSAT2);
  public columnsEcoSAT2 = [
    { text: 'Id', columntype: 'textbox', filtertype: 'textbox', datafield: 'id', width: 60, hidden: true },
    { text: '', columntype: 'image', datafield: 'imagen', width: 16, cellsrenderer: this.imageRenderer, menu: false },
    {
      text: 'Modelo', columntype: 'textbox', filtertype: 'textbox', datafield: 'nombre', width: 310,
      aggregates: [{
        'Total': function (aggregatedValue, currentValue: number) {
          return currentValue ? aggregatedValue + 1 : 1;
        }
      }],
      aggregatesrenderer: function (aggregates) {
        let renderstring = '';
        if (aggregates["Total"] !== undefined) {
          renderstring = '<div style="text-align: left; margin-left: 4px; padding-top:2px;">' + aggregates["Total"] + ' modelos</div>';
        }
        return renderstring;
      },
    },
    { text: 'Tipo', columntype: 'textbox', filtertype: 'textbox', datafield: 'tipo', width: 350 },
    {
      text: 'Unidades', columntype: 'textbox', filtertype: 'textbox', datafield: 'unidades', width: 70,
      align: 'center', cellsalign: 'center',
      aggregates: [{
        'Total': function (aggregatedValue, currentValue: number) {
          return currentValue ? aggregatedValue + currentValue : aggregatedValue;
        }
      }],
      aggregatesrenderer: function (aggregates) {
        let renderstring = '';
        if (aggregates["Total"] !== undefined) {
          renderstring = '<div style="text-align: center; padding-top:2px;">' + aggregates["Total"] + ' </div>';
        }
        return renderstring;
      }
    },
  ];

  // Variables para el grid de la BDT
  public sourceBDT: any = [];
  public dataAdapterBDT = new jqx.dataAdapter(this.sourceBDT);
  public columnsBDT = [
    { text: 'Id', columntype: 'textbox', filtertype: 'textbox', datafield: 'id', width: 60, hidden: true },
    { text: '', columntype: 'image', datafield: 'imagen', width: 16, cellsrenderer: this.imageRenderer, menu: false },
    {
      text: 'Marca', columntype: 'textbox', filtertype: 'textbox', datafield: 'marca', width: 100, cellsrenderer: this.rowRenderer,
      aggregates: [{
        'Total': function (aggregatedValue, currentValue: number) {
          return currentValue ? aggregatedValue + 1 : 1;
        }
      }],
      aggregatesrenderer: function (aggregates) {
        let renderstring = '';
        if (aggregates["Total"] !== undefined) {
          renderstring = '<div style="text-align: left; margin-left: 4px; padding-top:2px;">' + aggregates["Total"] + ' equipam.</div>';
        }
        return renderstring;
      }
    },
    { text: 'Modelo', columntype: 'textbox', filtertype: 'textbox', datafield: 'modelo', width: 150, cellsrenderer: this.rowRenderer },
    { text: 'Elemento', columntype: 'textbox', filtertype: 'textbox', datafield: 'elemento', width: 120, cellsrenderer: this.rowRenderer },
    { text: 'Residuos', columntype: 'textbox', filtertype: 'textbox', datafield: 'residuo', width: 120, cellsrenderer: this.rowRenderer },
    { text: 'Clase', columntype: 'textbox', filtertype: 'textbox', datafield: 'clase', width: 120, cellsrenderer: this.rowRenderer },
    {
      text: 'Capacidad', columntype: 'textbox', filtertype: 'textbox', datafield: 'capacidad', width: 80,
      align: 'center', cellsalign: 'center', cellsrenderer: this.rowRenderer
    },
    {
      text: 'Unidades', columntype: 'textbox', filtertype: 'textbox', datafield: 'unidades', width: 70,
      align: 'center', cellsalign: 'center', cellsrenderer: this.rowRenderer,
      aggregates: [{
        'Total2': function (aggregatedValue, currentValue: number) {
          return currentValue ? aggregatedValue + currentValue : aggregatedValue;
        }
      }],
      aggregatesrenderer: function (aggregates) {
        let renderstring = '';
        if (aggregates["Total2"] !== undefined) {
          renderstring = '<div style="text-align: center; padding-top:2px;">' + aggregates["Total2"] + ' </div>';
        }
        return renderstring;
      }
    }
  ];

  // Pongo por defecto los textos en los controles del grid en español
  public langGrid = JqWidgets.getLocalization('es');

  constructor(
    public apiService: ApiService,
    private confirmDialogService: ConfirmDialogService,
    private toastrService: ToastrService) {
    MainComponent.instance = this;
  }

  public static getInstance() {
    return MainComponent.instance;
  }

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
    setTimeout(async () => {
      // Recupero el ticket del SSO
      this.ticketSSO = this.apiService.getTicket();
      this.urlApi = this.ticketSSO.UrlApi;
      this.urlApiEcoSAT = this.ticketSSO.UrlApiEcoSAT;
      this.urlApiSSO = AppComponent.getInstance().urlApiSSO;
      // Compruebo la URL de origen
      if (AppComponent.getInstance().urlOrigin.startsWith('my.movisat.com')) {
        this.urlApiIntranet = 'https://api.intranet.movisat.com/api/v1';
        this.urlApiBDT = 'https://api.bdt.movisat.com';
        this.urlWeb = 'https://ecosat.np.movisat.com';
      } else {
        if (AppComponent.getInstance().urlOrigin.startsWith('preproduccion.my.movisat.com')) {
          this.urlApiIntranet = 'https://api.dev.intranet.movisat.com/api/v1';
          this.urlApiBDT = 'https://api.dev.bdt.movisat.com';
          this.urlWeb = 'https://ecosat.np.preproduccion.my.movisat.com';
        } else {
          this.urlApiIntranet = 'https://api.desa.intranet.movisat.com/api/v1';
          this.urlApiBDT = 'https://api.desa.bdt.movisat.com';
          this.urlWeb = 'https://ecosat.np.dev.movisat.com';
        }
      }

      // Esta variable se usa para indicar la URL de la Nueva Plataforma
      this.urlNP = this.urlWeb;

      this.btnConectar.disabled(true);
      this.cbEmpresas.focus();

      // Obtengo las empresas del SSO
      this.logInfo('Obteniendo token de ' + this.urlApiSSO);
      if (await this.apiService.getSSOApiToken()) {
        this.logSuccess('Ok');
        this.logInfo('Obteniendo empresas de ' + this.urlApiSSO);
        this.empresasSSO = await this.apiService.getEmpresasSSO();
        if (this.empresasSSO) {
          this.logSuccess('Ok, ' + this.empresasSSO.length + ' empresas');
          // Empieza la comunicación con la Intranet
          this.logInfo('Obteniendo token de ' + this.urlApiIntranet);
          if (await this.apiService.getIntranetApiToken()) {
            this.logSuccess('Ok');
            this.logInfo('Obteniendo empresas de ' + this.urlApiIntranet);
            this.empresasIntranet = await this.apiService.getEmpresasIntranet();
            if (this.empresasIntranet) {
              this.logSuccess('Ok');
              // Ordeno las empresas por nombre
              this.empresasIntranet.sort((a: any, b: any) => {
                if (a.descripcion > b.descripcion)
                  return 1;
                if (a.descripcion < b.descripcion)
                  return -1;
                return 0;
              });
              this.fillComboEmpresas();
              this.empresaId = this.empresasIntranet[0].id;
              this.empresaIdMoviles = this.empresasIntranet[0].id;
              this.cbEmpresas.selectIndex(0);
              this.cbEmpresas2.selectIndex(0);
              this.cbEmpresasNP.selectIndex(0);
              this.cbEmpresasNP2.selectIndex(0);
              this.btnConectar.disabled(false);
            }
          }
        }
      }
    }, 3000);
  }

  onColumnMenuOpening(menu: any, datafield: string, height: number) {
    if (menu && menu[0]) {
      let filterWidth = 175;
      let textLength = 0;
      let fontSize = 14;
      const elem0: any = menu[0].querySelectorAll('.jqx-listitem-state-normal');
      if (elem0.length > 0) {
        for (let i = 0; i < elem0.length; i++) {
          if (elem0[i].innerText.length > textLength) {
            textLength = elem0[i].innerText.length;
          }
          elem0[i].style['padding-left'] = '0px';
        }
      }
      if (textLength > 0) {
        if (textLength * fontSize > filterWidth) {
          filterWidth = Math.min(400, textLength * fontSize);
        }
      }
      menu.width(filterWidth);
      const elem1 = menu[0].querySelector('[id^="filter1jqxWidget"]');
      if (elem1) {
        elem1.style['width'] = (filterWidth - 13) + 'px';
      }
      const elem2 = menu[0].querySelector('[id^="listBoxContentfilter1jqxWidget"]');
      if (elem2) {
        elem2.style['width'] = (filterWidth - 33) + 'px';
      }
      const elem3 = menu[0].querySelector('[id^="verticalScrollBarfilter1jqxWidget"]');
      if (elem3) {
        elem3.style['left'] = (filterWidth - 30) + 'px';
      }
      const elem4 = menu[0].querySelector('[id^="horizontalScrollBarfilter1jqxWidget"]');
      if (elem4) {
        elem4.style['width'] = (filterWidth - 31) + 'px';
      }
      const elem5 = menu[0].querySelector('[id^="bottomRightfilter1jqxWidget"]');
      if (elem5) {
        elem5.style['left'] = (filterWidth - 29) + 'px';
      }
      const elem6 = menu[0].querySelector('[id^="jqxScrollBtnDownhorizontalScrollBarfilter1jqxWidget"]');
      if (elem6) {
        elem6.style['left'] = (filterWidth - 45) + 'px';
      }
    }
  }

  onColumnMenuClosing(menu: any, datafield: string, height: number) {
    if (menu && menu[0]) {
      menu.width(175);
    }
  }

  onClickTab(tab: number) {
    this.tabActive = tab;
  }

  public clearLog() {
    if (this.logArea) {
      this.logArea.innerHTML = '';
    }
  }

  public logInfo(text: string) {
    const line: any = document.createElement('div');
    line.style.cssText = 'float: left; clear: both; color: black;';
    line.innerHTML = DateUtils.formatTime(new Date()) + ' <span style="color: blue;">' + text + '</span>';
    const logArea = document.getElementById('logArea' + this.tabActive);
    logArea.appendChild(line);
    logArea.scrollTop = 999999999;
  }

  public logSuccess(text: string) {
    const line: any = document.createElement('div');
    line.style.cssText = 'float: left; clear: both; color: black;';
    line.innerHTML = DateUtils.formatTime(new Date()) + ' <span style="color: green;">' + text + '</span>';
    const logArea = document.getElementById('logArea' + this.tabActive);
    logArea.appendChild(line);
    logArea.scrollTop = 99999999;
  }

  public logError(text: string) {
    const line: any = document.createElement('div');
    line.style.cssText = 'float: left; clear: both; color: black;';
    line.innerHTML = DateUtils.formatTime(new Date()) + ' <span style="color: red;">' + text + '</span>';
    const logArea = document.getElementById('logArea' + this.tabActive);
    logArea.appendChild(line);
    logArea.scrollTop = 99999999;
  }

  rowRenderer(row: number, columnfield: string, value: any, defaulthtml: string, columnproperties: any, rowdata: any) {
    if (columnfield === 'modelo' && MainComponent.getInstance().equipModelos) {
      if (MainComponent.getInstance().equipModelos.get(rowdata.id)) {
        return '<div style="background-color: #10107c; color: white;">' + value + '</div>';
      }
    }
  }

  imageRenderer(row: number, columnfield: string, value: any, defaulthtml: string, columnproperties: any, rowdata: any) {
    if (value && value.length > 10) {
      return '<img style="margin-left: 4px; margin-top: 2px;" height="16" width="16" src="data:image/jpg;base64,' + value + '"/>';
    }
  }

  onSelectEmpresa(event: any) {
    this.cbEmpresas2.selectItem(event.args.item);
    this.cbEmpresasNP.selectItem(event.args.item);
    // this.empresaId = event.args.item.value;
    // this.urlApiEcoSAT = undefined;
    // this.urlApi = this.ticketSSO.UrlApi;
    // this.ebUrlApi.value(this.urlApi);
    // this.urlNP = this.urlWeb;
    // this.empresasIntranet.forEach(async (emp) => {
    //   if (emp.id === this.empresaId) {
    //     this.urlApiEcoSAT = emp.urlServicios ? emp.urlServicios : '';
    //     this.ebUrlApiEcoSAT.value(emp.urlServicios ? emp.urlServicios : '');
    //     if (emp.urlNP) {
    //       this.urlApi = emp.urlNP;
    //       this.ebUrlApi.value(this.urlApi);
    //     }
    //     const empSOO = this.empresasSSO.find(x => x.IdGestion === emp.idProyecto);
    //     if (empSOO) {
    //       const appEmp = await this.apiService.getAplicacionesConfigEmpresaSSO(empSOO.Id);
    //       if (appEmp) {
    //         const ecosat = appEmp.find(x => x.AplicacionId === 1); // 1=EcoSAT
    //         if (ecosat) {
    //           this.urlNP = ecosat.UrlWeb;
    //         }
    //       }
    //     }
    //   }
    // });
  }

  onSelectEmpresa2(event: any) {
    this.cbEmpresas.selectItem(event.args.item);
    this.cbEmpresasNP2.selectItem(event.args.item);
    // this.empresaIdMoviles = event.args.item.value;
    // this.urlApiEcoSAT = undefined;
    // this.empresasIntranet.forEach(emp => {
    //   if (emp.id === this.empresaIdMoviles) {
    //     this.urlApiEcoSAT = emp.urlServicios ? emp.urlServicios : '';
    //     this.ebUrlApiEcoSAT.value(emp.urlServicios ? emp.urlServicios : '');
    //     if (emp.urlNP) {
    //       this.urlApi = emp.urlNP;
    //       this.ebUrlApi.value(this.urlApi);
    //     }
    //   }
    // });
  }

  onSelectEmpresaNP(event: any) {
    this.cbEmpresasNP2.selectItem(event.args.item);
    this.empresaId = event.args.item.value;
    this.urlApiEcoSAT = undefined;
    this.urlApi = this.ticketSSO.UrlApi;
    this.ebUrlApi.value(this.urlApi);
    this.urlNP = this.urlWeb;
    this.empresasIntranet.forEach(async (emp) => {
      if (emp.id === this.empresaId) {
        this.urlApiEcoSAT = emp.urlServicios ? emp.urlServicios : '';
        this.ebUrlApiEcoSAT.value(emp.urlServicios ? emp.urlServicios : '');
        if (emp.urlNP) {
          this.urlApi = emp.urlNP;
          this.ebUrlApi.value(this.urlApi);
        }
        const empSOO = this.empresasSSO.find(x => x.IdGestion === emp.idProyecto);
        if (empSOO) {
          const appEmp = await this.apiService.getAplicacionesConfigEmpresaSSO(empSOO.Id);
          if (appEmp) {
            const ecosat = appEmp.find(x => x.AplicacionId === 1); // 1=EcoSAT
            if (ecosat) {
              this.urlNP = ecosat.UrlWeb;
            }
          }
        }
      }
    });
  }

  onSelectEmpresaNP2(event: any) {
    this.cbEmpresasNP.selectItem(event.args.item);
    this.empresaIdMoviles = event.args.item.value;
    this.urlApiEcoSAT = undefined;
    this.empresasIntranet.forEach(emp => {
      if (emp.id === this.empresaIdMoviles) {
        this.urlApiEcoSAT = emp.urlServicios ? emp.urlServicios : '';
        this.ebUrlApiEcoSAT.value(emp.urlServicios ? emp.urlServicios : '');
        if (emp.urlNP) {
          this.urlApi = emp.urlNP;
          this.ebUrlApi.value(this.urlApi);
        }
      }
    });
  }

  onConectar(event: any) {
    this.confirmDialogService.confirmThis(
      'Quiere iniciar el proceso de conexión a EcoSAT ?', () => {
        this.conectar();
      }, () => {
      });
  }

  async conectar() {
    try {
      this.conectando = true;
      this.procesoCancelado = false;
      this.loader.open();
      this.clearLog();
      this.modelElemEcoSAT = [];
      this.elementosEcoSAT = [];
      this.equipamientosBDT = [];
      this.unidadesModElem = new Map<number, number>();
      this.modelosEquip = new Map<number, BdtEquipamientoModel>();
      this.equipModelos = new Map<number, ModElemModel[]>();
      this.fillGridModElemEcoSAT();
      this.fillGridEquipamientosBDT();
      this.fillGridModElemSelec([]);
      this.empresaGestionId = 0;
      this.empresasIntranet.forEach(emp => {
        if (emp.id === this.empresaId) {
          this.empresaGestionId = emp.idProyecto;
          this.empresaNombre = emp.descripcion;
        }
      });
      if (this.urlApiSSO.length < 1) {
        this.toastrService.error('No ha indicado la URL para la API del SSO', 'ATENCIÓN', {
          timeOut: 2000,
          positionClass: 'toast-top-center',
          enableHtml: true
        });
        return;
      }
      if (this.urlApi.length < 1) {
        this.toastrService.error('No ha indicado la URL para la API de la Nueva Plataforma', 'ATENCIÓN', {
          timeOut: 2000,
          positionClass: 'toast-top-center',
          enableHtml: true
        });
        return;
      }
      if (this.urlApiEcoSAT.length < 1) {
        this.toastrService.error('No ha indicado la URL para la API de EcoSAT', 'ATENCIÓN', {
          timeOut: 2000,
          positionClass: 'toast-top-center',
          enableHtml: true
        });
        return;
      }
      // Empieza la comunicación
      if (this.empresaGestionId > 0) {
        this.logInfo('Obteniendo token de ' + this.urlApiSSO);
        if (await this.apiService.getSSOApiToken()) {
          this.logSuccess('Ok');
          this.logInfo('Obteniendo token de ' + this.urlApiEcoSAT);
          if (await this.apiService.getEcoSATApiToken()) {
            this.logSuccess('Ok');
            this.logInfo('Obteniendo token de ' + this.urlApi);
            if (await this.apiService.getNPApiToken()) {
              this.logSuccess('Ok');
              this.logInfo('Obteniendo modelos de elementos de EcoSAT');
              this.modelElemEcoSAT = await this.apiService.getModElementosEcoSAT(this.empresaGestionId);
              if (this.modelElemEcoSAT) {
                this.logSuccess('Ok');
                this.fillGridModElemEcoSAT();
                this.logInfo('Obteniendo token de ' + this.urlApiBDT);
                if (await this.apiService.getBDTApiToken()) {
                  this.logSuccess('Ok');
                  this.logInfo('Obteniendo equipamientos de la BDT de la empresa');
                  this.equipamientosBDT = await this.apiService.getEquipamientosBDTEmpresa(this.empresaGestionId);
                  if (!this.equipamientosBDT || this.equipamientosBDT.length < 1 || this.verEquipamientoGral) {
                    this.logInfo('Obteniendo equipamientos de la BDT generales');
                    const equipGral = await this.apiService.getEquipamientosBDT();
                    if (equipGral) {
                      equipGral.forEach(equip => {
                        this.equipamientosBDT.push(equip);
                      });
                    }
                  }
                  if (this.equipamientosBDT) {
                    this.logSuccess('Ok');
                    this.fillGridEquipamientosBDT();
                    this.logInfo('Obteniendo elementos');
                    await this.apiService.getElementosEcoSAT(this.empresaGestionId);
                  }
                }
              }
            }
          }
        }
        // Recupero la anterior selección y reproduzco paso a paso
        // los click de ratón para que se aplique
        const selection: SelectionModel[] = await this.getStateSelection();
        if (selection) {
          selection.forEach(equip => {
            if (equip.modelos) {
              const rows = this.gridBDT.getrows();
              if (rows) {
                rows.forEach(row => {
                  if (row.id === equip.equipamientoId) {
                    this.gridBDT.selectrow(row.boundindex);
                    this.equipSelec = this.equipamientosBDT.find(x => x.id === row.id);
                    if (equip.modelos && equip.modelos.length) {
                      const rows = this.gridEcoSAT.getrows();
                      if (rows && rows.length > 0) {
                        equip.modelos.forEach(model => {
                          this.modelElemEcoSAT.forEach((modEco, i) => {
                            if (modEco.Codigo === model.Codigo) {
                              this.gridEcoSAT.selectrow(i);
                            }
                          });
                        });
                        this.onAddModels(this.btnAddModel);
                      }
                    }
                  }
                });
              }
            }
          });
        }
      } else {
        this.toastrService.error('No ha seleccionado la empresa', 'ATENCIÓN', {
          timeOut: 2000,
          positionClass: 'toast-top-center',
          enableHtml: true
        });
      }
    } catch (e) {
      this.logError(e.message);
    } finally {
      this.loader.close();
      this.conectando = false;
      this.cancelar = false;
    }
  }

  async onCancelar(event: any) {
    if (this.conectando || this.procesando) {
      this.confirmDialogService.confirmThis(
        'Quiere cancelar el proceso ?', () => {
          this.cancelar = this.conectando || this.procesando;
          this.procesoCancelado = true;
        }, () => {
        });
    }
  }

  fillComboEmpresas() {
    this.cbEmpresas.clear();
    this.cbEmpresas2.clear();
    this.cbEmpresasNP.clear();
    this.cbEmpresasNP2.clear();
    this.empresasIntranet.forEach(emp => {
      this.cbEmpresas.addItem({ label: emp.descripcion + ' | ' + emp.idProyecto, value: emp.id });
      this.cbEmpresas2.addItem({ label: emp.descripcion + ' | ' + emp.idProyecto, value: emp.id });
      this.cbEmpresasNP.addItem({ label: emp.descripcion + ' | ' + emp.idProyecto, value: emp.id });
      this.cbEmpresasNP2.addItem({ label: emp.descripcion + ' | ' + emp.idProyecto, value: emp.id });
    });
  }

  fillGridModElemEcoSAT() {
    if (this.modelElemEcoSAT) {
      this.sourceEcoSAT = {
        datatype: 'json',
        datafields: [
          { name: 'id', type: 'number', map: 'Codigo' },
          { name: 'imagen', type: 'image', map: 'IconoElementoHex' },
          { name: 'nombre', type: 'string', map: 'Nombre' },
          { name: 'tipo', type: 'string', map: 'TipoModelo>Nombre' },
          // { name: 'capacidad', type: 'number', map: 'Capacidad' },
          { name: 'unidades', type: 'number', map: 'Unidades' },
          { name: 'visible', type: 'number', map: 'visible' }
        ],
        localdata: this.modelElemEcoSAT,
        sortcolumn: 'nombre',
        sortdirection: 'asc'
      };
      this.dataAdapterEcoSAT = new jqx.dataAdapter(this.sourceEcoSAT);
      this.gridEcoSAT.updatebounddata('data');
    }
  }

  fillGridModElemSelec(modelos: ModElemModel[]) {
    if (modelos) {
      this.sourceEcoSAT2 = {
        datatype: 'json',
        datafields: [
          { name: 'id', type: 'number', map: 'Codigo' },
          { name: 'imagen', type: 'image', map: 'IconoElementoHex' },
          { name: 'nombre', type: 'string', map: 'Nombre' },
          { name: 'tipo', type: 'string', map: 'TipoModelo>Nombre' },
          { name: 'unidades', type: 'number', map: 'Unidades' }
        ],
        localdata: modelos,
        sortcolumn: 'nombre',
        sortdirection: 'asc'
      };
      this.dataAdapterEcoSAT2 = new jqx.dataAdapter(this.sourceEcoSAT2);
      this.gridEcoSAT2.updatebounddata('data');
    }
  }

  public onNewElements(total: number, elementos: ElementoModel[]) {
    if (this.elementosEcoSAT.length < 1) {
      this.logInfo('Preparado para recibir ' + total + ' elementos aproximadamente');
    }
    elementos.forEach(elem => {
      // Si se trata de un elemento con volumétrcio asociado...
      if (elem.IMEI_WellNess && elem.IMEI_WellNess.length > 1) {
        // Si el elemento no tiene frecuencia configurada la busco en el modelo
        if (!elem.FrecuenciaIdVolumetrico || elem.FrecuenciaIdVolumetrico < 1) {
          const model = ApiService.modElementos.get(elem.CodModelo);
          if (model && model.FrecuenciaIdVolumetrico && model.FrecuenciaIdVolumetrico > 0) {
            elem.FrecuenciaIdVolumetrico = model.FrecuenciaIdVolumetrico;
          }
        }
      }
      this.elementosEcoSAT.push(elem);
    });
    this.logInfo('Recibido paquete de ' + elementos.length + ' elementos, restan ' + (total - this.elementosEcoSAT.length));
    if (this.elementosEcoSAT.length >= total) {
      this.logSuccess('Se han recibido un total de ' + this.elementosEcoSAT.length + ' elementos');
    }
    // Actualizo el número de unidades en el grid de modelos
    elementos.forEach(elem => {
      let num = this.unidadesModElem.get(elem.CodModelo);
      this.unidadesModElem.set(elem.CodModelo, num ? num + 1 : 1);
    });
    this.modelElemEcoSAT.forEach(model => {
      model.Unidades = this.unidadesModElem.get(model.Codigo);
      if (!model.Unidades) {
        model.Unidades = 0;
      }
    });
    this.gridEcoSAT.beginupdate();
    const scrollPos = this.gridEcoSAT.scrollposition();
    this.gridEcoSAT.updatebounddata('cells');
    this.gridEcoSAT.endupdate();
    this.gridEcoSAT.scrolloffset(scrollPos.top, scrollPos.left);
  }

  fillGridEquipamientosBDT() {
    if (this.equipamientosBDT) {
      this.sourceBDT = {
        datatype: 'json',
        datafields: [
          { name: 'id', type: 'number', map: 'id' },
          { name: 'imagen', type: 'image', map: 'icono' },
          { name: 'marca', type: 'string', map: 'marca>nombre' },
          { name: 'modelo', type: 'string', map: 'modelo>nombre' },
          { name: 'elemento', type: 'string', map: 'elemento>nombre' },
          { name: 'residuo', type: 'string', map: 'residuoStr' },
          { name: 'clase', type: 'string', map: 'claseStr' },
          { name: 'capacidad', type: 'number', map: 'capacidad_litros' },
          { name: 'unidades', type: 'number', map: 'unidades' },
        ],
        localdata: this.equipamientosBDT,
        sortcolumn: 'residuo',
        sortdirection: 'asc'
      };
      this.dataAdapterBDT = new jqx.dataAdapter(this.sourceBDT);
      this.gridBDT.updatebounddata('data');
    }
  }

  // Cuando se selecciona un equipamiento
  onRowClickEquipamiento(event: any) {
    const rowSel = this.gridBDT.getselectedrowindexes();
    this.equipSelec = this.equipamientosBDT[event.args.rowindex];
    // Relleno el grid de modelos asignados al equipamiento seleccionado
    let models: ModElemModel[] = this.equipModelos.get(this.equipSelec.id);
    if (!models) {
      models = [];
    }
    this.fillGridModElemSelec(models);
  }

  onAddModels(event: any) {
    if (!this.equipSelec) {
      this.toastrService.error('Seleccione un equipamento', 'ATENCIÓN', {
        timeOut: 2000,
        positionClass: 'toast-top-center',
        enableHtml: true
      });
      return;
    }
    // Añado los modelos seleccionados del equipamiento
    const rowsSelec = this.gridEcoSAT.getselectedrowindexes();
    if (rowsSelec) {
      let models: ModElemModel[] = this.equipModelos.get(this.equipSelec.id);
      if (!models) {
        models = [];
      }
      rowsSelec.forEach(i => {
        // Asigno al equipamiento el icono del modelo
        this.equipSelec.icono = this.modelElemEcoSAT[i].IconoElementoHex;
        models.push(this.modelElemEcoSAT[i]);
        this.modelosEquip.set(this.modelElemEcoSAT[i].Codigo, this.equipSelec);
        this.modelElemEcoSAT[i].visible = 'false';
        this.modelElemEcoSAT[i].borrar = false;
        this.equipamientosBDT.forEach(equip => {
          if (equip.id === this.equipSelec.id) {
            equip.unidades += this.modelElemEcoSAT[i].Unidades;
          }
        });
      });
      this.equipModelos.set(this.equipSelec.id, models);
      // Compruebo si ya he creado el filtro "visible" anteriormente
      const filters = this.gridEcoSAT.getfilterinformation();
      if (filters.find(s => s.datafield === 'visible') === undefined) {
        const filtergroup = new jqx.filter();
        filtergroup.addfilter(1, filtergroup.createfilter('stringfilter', 'true', 'equal'));
        this.gridEcoSAT.addfilter('visible', filtergroup, true);
      }
      this.gridEcoSAT.applyfilters();
      this.gridEcoSAT.updatebounddata('data');
      this.fillGridModElemSelec(models);
      // Actualizo el grid de equipamientos
      this.gridBDT.beginupdate();
      const scrollPos = this.gridBDT.scrollposition();
      this.gridBDT.updatebounddata('cells');
      this.gridBDT.endupdate();
      this.gridBDT.scrolloffset(scrollPos.top, scrollPos.left);
      // Limpio la selección
      this.gridEcoSAT.clearselection();
    }
    this.setStateSelection();
  }

  onDeleteModels(event: any) {
    if (!this.equipSelec) {
      this.toastrService.error('Seleccione un equipamento', 'ATENCIÓN', {
        timeOut: 2000,
        positionClass: 'toast-top-center',
        enableHtml: true
      });
      return;
    }
    const rowsSelec = this.gridEcoSAT2.getselectedrowindexes();
    if (rowsSelec) {
      // Quito los modelos seleccionados del equipamiento
      let models: ModElemModel[] = this.equipModelos.get(this.equipSelec.id);
      if (models && models.length > 0) {
        rowsSelec.forEach(i => {
          this.modelosEquip.delete(models[i].Codigo);
          this.modelElemEcoSAT.forEach(model => {
            if (model.Codigo === models[i].Codigo) {
              model.visible = 'true';
              models[i].borrar = true;
              this.equipamientosBDT.forEach(equip => {
                if (equip.id === this.equipSelec.id) {
                  equip.unidades -= model.Unidades;
                  if (equip.unidades < 1) {
                    equip.icono = '';
                  }
                }
              });
            }
          });
        });
        // Almaceno los modelos que todavía siguen asignados
        let models2: ModElemModel[] = [];
        models.forEach(model => {
          if (!model.borrar) {
            models2.push(model);
          }
        });
        if (models2.length > 0) {
          this.equipModelos.set(this.equipSelec.id, models2);
        } else {
          this.equipModelos.delete(this.equipSelec.id);
        }
        // Actualizo el grid de modelos disponibles
        this.gridEcoSAT.applyfilters();
        this.gridEcoSAT.updatebounddata('data');
        // Actualizo el grid de modelos asignados
        this.fillGridModElemSelec(models2);
        // Actualizo el grid de equipamientos
        this.gridBDT.beginupdate();
        const scrollPos = this.gridBDT.scrollposition();
        this.gridBDT.updatebounddata('cells');
        this.gridBDT.endupdate();
        this.gridBDT.scrolloffset(scrollPos.top, scrollPos.left);
        // Limpio la selección
        this.gridEcoSAT2.clearselection();
      }
    }
    this.setStateSelection();
  }

  private async setStateSelection() {
    const selection: SelectionModel[] = [];
    for (const [key, value] of this.equipModelos) {
      const value2 = this.clone(value);
      if (value2) {
        value2.forEach(ele => {
          ele.IconoElementoHex = null;
          ele.IconoPuntoHex = null;
        });
      }
      selection.push(new SelectionModel(key, value2));
    }

    this.toastrService.info('Configuración almacenada', 'ATENCIÓN', {
      timeOut: 2000,
      positionClass: 'toast-top-center',
      enableHtml: true
    });

    //localStorage.setItem("ecoimport-" + this.empresaId, JSON.stringify(selection));
    return await this.apiService.setConfigNP(this.empresaGestionId, "ecoimport-config", JSON.stringify(selection));
  }

  private async getStateSelection() {
    let result;
    const res0 = await this.apiService.getConfigNP(this.empresaGestionId, "ecoimport-config", "");
    // Si no encuentro nada en BD busco en localstorage
    if (!res0 || res0.length == 0) {
      result = JSON.parse(localStorage.getItem("ecoimport-" + this.empresaId));
      if (await this.apiService.setConfigNP(this.empresaGestionId, "ecoimport-config", JSON.stringify(result))) {
        // Una vez que se almacena en BD la borro de localstorage
        localStorage.removeItem("ecoimport-" + this.empresaId);

        this.toastrService.info('Configuración almacenada', 'ATENCIÓN', {
          timeOut: 2000,
          positionClass: 'toast-top-center',
          enableHtml: true
        });

      }
    } else {
      result = JSON.parse(res0);
    }
    return result;
  }

  // Crea todos los elementos en la NP
  onProcesarElementos(event: any) {
    this.confirmDialogService.confirmThis('Quiere iniciar el proceso de importación de elementos ?', async () => {
      try {
        this.logInfo('Obteniendo token de ' + this.urlApi);
        if (await this.apiService.getNPApiToken()) {
          this.logSuccess('Ok');
        }
        this.procesando = true;
        this.loader.open();
        this.logInfo('Creando catálogos de equipamiento');
        let totElem = 0;
        let totEquip = 0;
        // Cuento el total de equipamientos que se van a crear
        this.equipamientosBDT.forEach(eq => {
          if (this.equipModelos.get(eq.id)) {
            totEquip++;
          }
        });
        // Compruebo si se ha marcado borrar elementos
        if (this.borrarElementos) {
          this.apiService.deleteElementosEmpresa(this.empresaGestionId);
        }
        for (let i = 0, j = totEquip; i < this.equipamientosBDT.length; i++) {
          const equip = this.equipamientosBDT[i];
          const models: ModElemModel[] = this.equipModelos.get(equip.id);
          if (models) {
            let unidades = 0;
            models.forEach(model => {
              unidades += model.Unidades;
            });
            if (unidades > 0) {
              this.logInfo('Creando catálogo ' + equip.marca.nombre + ' | ' +
                equip.modelo.nombre + ' | ' + unidades + ' unidades');
              const cat = new BdtCatalogoEquipModel();
              cat.idEquipamiento = equip.id;
              cat.idProyecto = this.empresaGestionId;
              cat.unidades = unidades;
              cat.icono = equip.icono;
              cat.urlApiSSO = this.urlApiSSO;
              cat.urlApiNP = this.urlApi;
              cat.urlApiEcoSAT = this.urlApiEcoSAT;
              cat.urlApiIA = this.urlApiIA;
              cat.urlWeb = this.urlNP;
              cat.borrar = (j === totEquip && this.borrarEquipamiento);
              cat.ultimo = (j === 1);
              j--;
              if (this.cancelar) {
                this.logError('Proceso cancelado por el usuario');
                return;
              }
              // Mando crear el catálogo de equipamiento
              if (await this.apiService.saveCatEquipamiento(cat)) {
                this.logSuccess('Ok');
                this.logInfo('Creando ' + unidades + ' elementos del catálogo')
                let elementos: ElementoNPModel[] = [];
                let count = 0;
                for (let i = 0; i < this.elementosEcoSAT.length; i++) {
                  if (this.cancelar) {
                    this.logError('Proceso cancelado por el usuario');
                    return;
                  }
                  const elem = this.elementosEcoSAT[i];
                  const equipElem = this.modelosEquip.get(elem.CodModelo);
                  if (equipElem && equipElem.id === equip.id) {
                    elementos.push(new ElementoNPModel(this.empresaGestionId, elem.Nombre, elem.Lat, elem.Lng,
                      equip.id, Guid.create().toString(), elem.IMEI_WellNess, new Date(elem.FechaUltimaLecturaVolumetrico),
                      elem.UltimaLecturaVolumetrico, elem.UltimoPorcentajeVolumetrico, 0, 0, elem.FrecuenciaIdVolumetrico,
                      elem.Codigo, elem.ContainerID_WellNess, elem.InstalacionVolumetrico, elem.EstadoInstalacionVolumetrico,
                      elem.Calle, '', elem.Provincia, elem.Comunidad, elem.Municipio, elem.Poblacion, '', 'España'
                    ));
                    if (elementos.length >= 1000) {
                      count += elementos.length;
                      this.logInfo('Creando paquete de ' + elementos.length + ' elementos, restan ' + (unidades - count));
                      if (!await this.apiService.saveElementos(elementos)) {
                        this.logError("Se ha producido un error, proceso cancelado")
                        return;
                      }
                      elementos = [];
                    }
                  }
                  if (i === this.elementosEcoSAT.length - 1) {
                    if (elementos.length > 0) {
                      count += elementos.length;
                      this.logInfo('Creando paquete de ' + elementos.length + ' elementos');
                      if (!await this.apiService.saveElementos(elementos)) {
                        this.logError("Se ha producido un error, proceso cancelado")
                        return;
                      }
                    }
                  }
                }
                totElem += count;
              } else {
                this.logError("Se ha producido un error, proceso cancelado")
                return;
              }
            }
          }
        }
        this.logInfo('El proceso de importación de elementos ha finalizado');
        this.logSuccess('Se han creado un total de ' + totElem + ' elementos');
        if (this.importarMoviles) {
          this.importMoviles(this.empresaGestionId);
        } else {
          this.logInfo('Proceso finalizo, satisfactoriamente');
        }
      } catch (e) {
        this.logError(e.message);
      } finally {
        this.loader.close();
        setTimeout(() => {
          this.procesando = false;
          this.cancelar = false;
        }, 5000);
      }
    }, () => {
    });
  }

  // Importa los móviles de la empresa
  async onProcesarMoviles(event: any) {
    let empresaId = 0;
    this.empresaGestionId = 0;
    this.empresasIntranet.forEach(emp => {
      if (emp.id === this.empresaIdMoviles) {
        empresaId = emp.idProyecto;
        this.empresaGestionId = emp.idProyecto;
        this.empresaNombre = emp.descripcion;
      }
    });
    if (empresaId < 1) {
      this.toastrService.error('No ha seleccionado la empresa', 'ATENCIÓN', {
        timeOut: 2000,
        positionClass: 'toast-top-center',
        enableHtml: true
      });
      return;
    }
    if (!this.crearEmpresa) {
      const empresas = await this.apiService.getEmpresasApp(1);
      if (!empresas || !empresas.find(e => e.IdGestion === this.empresaGestionId)) {
        await this.confirmDialogService.confirmThis('La empresa no existe en el SSO o no tiene acceso a EcoSAT. ' +
          'Quiere crearla en este momento y/o asignar los accesos ?', async () => {
            this.crearEmpresa = true;
            this.inicioImportMoviles(empresaId);
          }, () => {
            this.crearEmpresa = false;
            this.inicioImportMoviles(empresaId);
          });
      } else {
        this.inicioImportMoviles(empresaId);
      }
    } else {
      this.inicioImportMoviles(empresaId);
    }
  }

  inicioImportMoviles(empresaId: number) {
    this.confirmDialogService.confirmThis('Quiere iniciar el proceso de importación de móviles ?', async () => {
      this.clearLog();
      if (this.crearEmpresa) {
        let empresa = await this.apiService.getEmpresaGestion(this.empresaGestionId);
        if (!empresa) {
          this.logInfo('Creando empresa');
          if ((empresa = await this.apiService.saveEmpresa({
            EmpresaNombre: this.empresaNombre,
            EmpresaIdGestion: this.empresaGestionId,
            EmpresaIdCartografia: 1
          }))) {
            this.logSuccess('Ok');
          }
        }
        if (empresa) {
          let appEmp = await this.apiService.getEmpresaApp(empresa.Id, 1);
          if (!appEmp) {
            this.logInfo('Asignando aplicación EcoSAT a la empresa');
            if ((appEmp = await this.apiService.saveEmpresaApp({
              EmpresaId: empresa.Id,
              AplicacionId: 1, // EcoSAT
              UrlApi: this.urlApi,
              UrlApiIA: this.urlApiIA,
              UrlWeb: this.urlNP,
              UrlApiEcoSAT: this.urlApiEcoSAT
            }))) {
              this.logSuccess('Ok');
            }
          }
          if (appEmp) {
            let accUsu = await this.apiService.getUsuarioAcceso('soporte@movisat.com', empresa.Id, 1, 3);
            if (!accUsu) {
              this.logInfo('Dando acceso a soporte@movisat.com');
              if ((accUsu = await this.apiService.saveAccesoUsuarioEmpApp({
                UsuarioLogin: 'soporte@movisat.com',
                EmpresaId: empresa.Id,
                AplicacionId: 1, // EcoSAT
                RolId: 3 // Administrador
              }))) {
                this.logSuccess('Ok');
              }
            }
          }
        }
      }
      this.logInfo('Obteniendo token de ' + this.urlApi);
      if (await this.apiService.getNPApiToken()) {
        this.logSuccess('Ok');
        this.importMoviles(empresaId);
      }
    }, () => {
    });
  }

  async importMoviles(empresaId: number) {
    try {
      this.loader.open();
      this.logInfo('Importando móviles desde ' + this.urlApiEcoSAT);
      const moviles = await this.apiService.saveMoviles(empresaId);
      if (moviles) {
        this.logSuccess('Ok');
        this.logInfo('El proceso de importación de móviles ha finalizado');
        if (moviles.length > 0) {
          this.logSuccess('Se han creado un total de ' + moviles.length + ' móviles');
          this.logInfo('Obteniendo token de ' + this.urlApiEcoSAT);
          if (await this.apiService.getEcoSATApiToken()) {
            this.logSuccess('Ok');
            this.logInfo('Recuperando últimas posiciones de los móviles');
            const posiciones = await this.apiService.getUltimasPosiciones(empresaId);
            let res = true;
            if (posiciones) {
              const newPos: PosicionNPModel[] = [];
              posiciones.forEach(pos => {
                newPos.push(new PosicionNPModel(pos.Movil, new Date(pos.Fecha), pos.Ignicion > 0, pos.Lat,
                  pos.Lng, pos.Velocidad, pos.Altura, pos.Rumbo, pos.Estado));
              });
              if (newPos.length > 0) {
                res = await this.apiService.savePosiciones(newPos);
              }
            }
            if (res) {
              this.logSuccess('Ok');
              this.logInfo('Proceso finalizo, satisfactoriamente');
            } else {
              this.logError('Proceso finalizado con error');
            }
          }
        } else {
          this.logSuccess('No se han encontrado móviles en la empresa seleccionada');
        }
      } else {
        this.logError('Se ha producido un error, proceso cancelado');
      }
    } catch (e) {
      this.logError(e.message);
    } finally {
      this.loader.close();
    }
  }

  private clone<T>(a: T): T {
    return JSON.parse(JSON.stringify(a));
  }

  public getEnvironment(): string {
    switch (this.urlWeb) {
      case 'https://ecosat.np.movisat.com':
        return '* PRODUCCIÓN *';
      case 'https://ecosat.np.preproduccion.my.movisat.com':
        return '* PRE-PRODUCCIÓN *';
      default:
        return '* DESARROLLO *';
    }
  }

}
